import React from "react";
import { Link } from "react-router-dom";
import { APP_ROUTES } from "../constants/appRoutes";
import AuthLayout from "./auth/AuthLayout";
import "../App.css";
import "bootstrap-icons/font/bootstrap-icons.css";

const AccountLocked = () => {
  return (
    <AuthLayout>
      <div className="text-center">
        <span
          className="mb-4 inline-flex h-14 w-14 items-center justify-center rounded-full bg-red-100 text-red-600"
          aria-hidden
        >
          <i className="bi bi-shield-lock text-2xl" />
        </span>
        <h1 className="mb-2 text-xl font-bold text-slate-900">Account locked</h1>
        <p className="mb-4 text-sm text-slate-600">
          Your account has been locked due to too many failed verification attempts.
        </p>
        <p className="mb-6 text-sm text-slate-600">
          Please contact support to unlock your account. Login and activation are disabled until
          your account is unlocked.
        </p>
        <Link className="btn btn-primary-app inline-block w-full font-semibold" to={APP_ROUTES.HOME}>
          Back to home
        </Link>
      </div>
    </AuthLayout>
  );
};

export default AccountLocked;
